export const APARTMENTS_VERSION_COOKIE = 'apartments-ui-version';
